import React from 'react';
import { PLATFORMS } from '../../constants/platforms';
import { PlatformIconComponent } from '../icons/PlatformIcons';
import styles from './PlatformBadge.module.css';

function PlatformBadge({ platform }) {
  const info = PLATFORMS[platform];
  if (!info) return null;

  return (
    <span
      className={styles.badge}
      style={{ backgroundColor: info.color + '22', borderColor: info.color + '55', color: info.color }}
    >
      <PlatformIconComponent platform={platform} size={12} className={styles.icon} />
      <span className={styles.label}>{info.label}</span>
    </span>
  );
}

export default PlatformBadge;
